import request from '#/utils/request';
import { keysToSnake } from '#/api/adapters/wireCase';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * PUT 完整取代使用者 roles＋overrides。
 * @see docs/API_SYSTEM_ACCESS.md
 */
export async function replaceUserAccess(userId, payload) {
  const { data: raw } = await request.put(
    `/system/user/${userId}/access`,
    keysToSnake(payload ?? {}),
  );
  return parseVer4DetailResponse(raw);
}
